//Imports
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/auth';
import {config} from './fbconfig'; //Init

//Init
if (!firebase.apps.length) firebase.initializeApp(config);

export const fn = firebase.functions();
export const db = firebase.database();
export const auth = firebase.auth();
